import React from "react";
import { stampCity, stampLook } from "./stampStyle";

interface Props {
  city: string;
  /** 1 for the first stamp earned, and so on; omitted for one to earn. */
  ordinal?: number;
  /** Second line: the stamp's month and year, or "at 100%" for one to earn. */
  detail: string;
  /** A stamp not yet earned: dashed and grey. */
  pending?: boolean;
  /** Plays the landing animation (motion-safe only). */
  animate?: boolean;
  size?: number;
}

/** One stamp in the passport (UX_CONCEPT.md §7). */
export const PassportStamp: React.FC<Props> = ({
  city,
  ordinal = 0,
  detail,
  pending = false,
  animate = false,
  size = 74,
}) => {
  const look = stampLook(city, ordinal);
  const round = pending || look.shape === "round";
  return (
    // The rotation sits on the outer box so the animation can scale the inner.
    <div
      className="flex-none"
      style={{
        width: size,
        height: round ? size : Math.round(size * 0.9),
        transform: pending ? undefined : `rotate(${look.rotate}deg)`,
      }}
    >
      <div
        className={[
          "flex h-full w-full flex-col items-center justify-center text-center font-mono",
          round ? "rounded-full" : "rounded-[10px]",
          pending
            ? "border-2 border-dashed border-slate-300 text-muted-foreground"
            : `border-[2.5px] ${look.tone}`,
          animate ? "motion-safe:animate-stamp-in" : "",
        ].join(" ")}
      >
        <span
          className="max-w-full px-1 font-medium leading-tight tracking-[0.06em]"
          style={{ fontSize: Math.max(9, Math.round(size / 6.7)) }}
        >
          {stampCity(city)}
        </span>
        <span
          className={pending ? "" : "opacity-80"}
          style={{ fontSize: Math.max(8, Math.round(size / 8.2)) }}
        >
          {detail}
        </span>
      </div>
    </div>
  );
};
